import { useEffect, useState } from "react";
import type { AuthOptionsResponse } from "../../shared/api-types";
import { api } from "../api/client";

let cached: Promise<AuthOptionsResponse> | null = null;

/**
 * What the sign-in screens may offer (sign-up closed when REGISTRATION is "invite"; without an e-mail provider: no
 * reset e-mails), plus where the legal documents live.
 * null while loading, so nothing optional flashes in; if the call fails the links stay (the server still decides).
 */
export function useAuthOptions(): AuthOptionsResponse | null {
  const [options, setOptions] = useState<AuthOptionsResponse | null>(null);
  useEffect(() => {
    let live = true;
    cached ??= api<AuthOptionsResponse>("GET", "/auth/options").catch(() => {
      cached = null;
      return {
        registrationOpen: true,
        emailEnabled: true,
        googleEnabled: false,
        contactUrl: null,
        challengeSiteKey: null,
        termsUrl: null,
        privacyUrl: null,
      };
    });
    cached.then((o) => live && setOptions(o));
    return () => {
      live = false;
    };
  }, []);
  return options;
}
